import { action } from "typesafe-actions";
import { WcpCookieConsentActionTypes } from "./types";

export const setWcpCookieConsent = (hasConsent: boolean) =>
  action(WcpCookieConsentActionTypes.SET_COOKIE_CONSENT, hasConsent);
